module.exports = __webpack_public_path__ + "img/homeSolidIcon.8085c651.svg";